import 'angular-ui-notification';

export default angular.module('notifyModule', ['ui-notification']).service('notify', function(Notification) {
	let messages = [];

	this.success = (msg) => {
		Notification.success(msg);
		messages.push({msg: msg, type: 'success', date: new Date()});
	};

	this.error = (msg) => {
		Notification.error(msg);
		messages.push({msg: msg, type: 'danger', date: new Date()});
	};

	this.info = (msg) => {
		Notification.info(msg);
		messages.push({msg: msg, type: 'info', date: new Date()});
	};

	this.warning = (msg) => {
		Notification.warning(msg);
		messages.push({msg: msg, type: 'warning', date: new Date()});
	};


	this.getMessages = () => {
		return messages;
	}
}).name;



// WEBPACK FOOTER //
// build/services/notificationService/notificationService.js